module.exports = __webpack_public_path__ + "static/media/CTLI_12-315w.75cd77c0.jpg";